import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-save-button',
  templateUrl: './save-button.component.html',
  styleUrls: ['./save-button.component.scss']
})
export class SaveButtonComponent implements OnInit {

  @Input() color: ThemePalette = 'primary';
  @Input() disabled: boolean = false;
  @Input() text: string = '';
  @Input() loading: boolean = true;

  @Output() clickEvent: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  clickHandler() {
    this.clickEvent.emit();
  }
}
